module.exports = __webpack_public_path__ + "img/bg.10b70550.png";